import { Component, inject } from '@angular/core'
import { AnalyticsService } from '../../services/analytics.service'
import { LanguageService } from '../../services/language.service'

@Component({
    selector: 'endevelo-language-picker',
    templateUrl: './language-picker.component.html',
    styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent {
    readonly languageService = inject(LanguageService)
    private analytics = inject(AnalyticsService)

    switchLanguage(targetLang: 'en' | 'pl') {
        this.languageService.switchLanguage(targetLang)
        this.analytics.trackLanguageChange(targetLang)
    }
}
